const RECEIVE_ALL_CHARGEBACK_ISSUE_TYPES = 'src/chargeBackTypes/RECEIVE_ALL_CHARGEBACK_ISSUE_TYPES' as const;
const CLEAR_ALL_CHARGEBACK_ISSUE_TYPES = 'src/chargeBackTypes/CLEAR_ALL_CHARGEBACK_ISSUE_TYPES' as const;

export default {
  RECEIVE_ALL_CHARGEBACK_ISSUE_TYPES,
  CLEAR_ALL_CHARGEBACK_ISSUE_TYPES
};
